<template>
  <hs-form 
    ref="searchForm"
    class="hs-search-form" 
    :formData="formData" 
    :rules="rules"
    @search="searchBarSearch"
    :useDefaultChange="true"
    :showAll="open"
    label-position="right"
    :inline="true">

    <el-form-item class="search-operate" v-if="formData.length != 0">
      <el-button v-if="unfoldshow" type="text" @click="toggleFun" id="toggleSearch">
        <i :class="open?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
        {{open?t('hs.button.close'):t('hs.button.open')}}
      </el-button>
      <el-button type="primary" @click="submitForm" id="search">{{t('hs.button.search')}}</el-button>
      <el-button @click="resetForm" id="reset">{{t('hs.button.reset')}}</el-button>
    </el-form-item>
  </hs-form>
</template>

<script>
import HsForm from '../form'
import Locale from '../../mixins/locale';

export default {
  name: 'HsSearchBar',
  components: {
    HsForm,
  },
  mixins: [Locale],
    
  props: {
    /** 表单绑定数组对象 */
    formData: {
      type: Array,
      default(){
        return [];
      }
    },
    /** 表单校验规则 */
    rules: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed: {
    unfoldshow(){
      // let totalNum = this.formData.length || 0;
      let hasAdvance = this.formData.some(item => item.advanced)
      // let notShowNum = 0;
      // this.formData.map( item => {
      //   if(item.notShow == true){
      //     notShowNum += 1;
      //   }
      // });
      // let unfoldshow = (totalNum - notShowNum) > 3 ;
      return hasAdvance;
    },
  },
  data() {
    return {
      open:true
    }
  },
  methods: {
    searchBarSearch(formVal) {
      this.$emit('search', formVal);
    },
    submitForm() {
      if (this.$refs.searchForm) {
        this.$refs.searchForm.formSearch();
      }
    },
    resetForm() {
      if ( this.$refs.searchForm) {
        this.$refs.searchForm.resetForm();
        this.$emit('reset', this.$refs.searchForm.getFormModel());
        this.$emit('search', this.$refs.searchForm.getFormModel());
      }
    },
    getFormData() {
      if (this.$refs.searchForm) {
        let formVal = this.$refs.searchForm.getFormModel();
        return formVal
      } else {
        return {}
      }
    },
    toggleFun() {
      this.open = !this.open;
    }
  }
}
</script>

<style lang="scss">
@import '../../theme/var.scss';
.hs-search-form {
  text-align: left;
  background: $--color-white;
  border-radius: $--border-radius-large;
  margin-bottom: $--padding-base;
  padding: $--padding-base;
  padding-bottom: 0;

  .el-form-item {
    margin-bottom: $--padding-base;
    margin-right: 20px;
    .el-form-item__label{
      font-weight: 400;
    }
    .el-select,.el-input,.hs-tree-select,.el-date-editor{
      width: 175px;
      min-width: 0;
    }
    .el-range-editor{
      width: 320px;
    }

    .el-select__tags-text {
      display: inline-block;
      max-width: 55px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.hs-search-form::after {
  content: '';
  display: block;
  clear: both;
}
.search-operate{
  float: right;
  margin-right: 0!important;
  // .el-button{
  //   padding: 6px 20px !important;
  // }
}
</style>